(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.form = skyward.form || {};

        skyward.form.updateTextAreaSizes = function ()
        {
            updateTextAreaRestrictions($('.js-PreventNewLine'));
            skyward.form.updateTextAreaExpandSize($('.js-AutoExpand'));
        };


        const updateTextAreaRestrictions = function (textAreas)
        {
            textAreas.each(function (e)
            {
                e.bind('keypress', function (e)
                {
                    if ((e.keyCode || e.which) == 13)
                    {
                        e.preventDefault();
                        return false;
                    }
                });
            });
        };

        skyward.form.updateTextAreaExpandSize = function (textAreas)
        {
            textAreas.each(function (e)
            {
                const textArea = $(this);

                function updateTextAreaHeight()
                {
                    var placeholderText = textArea.attr('placeholder');
                    textArea.attr('placeholder', '');
                    textArea.height("");
                    textArea.height(textArea.prop('scrollHeight') + "px");
                    textArea.attr('placeholder', placeholderText);

                }
                updateTextAreaHeight();
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);